import { authMiddleware } from '@/router/middleware/authMiddleware'
import { roleMiddleware } from '@/router/middleware/roleMiddleware'
import RolesHelper from '@/helpers/Roles'
// import UserMenuConfig from '@/config/UserMenuConfig'

const user = [
    {
        path: '/',
        component: () => import('@/components/Layout/UserLayout.vue'),
        // props: {
        //     menu: UserMenuConfig,
        // },
        beforeEnter: [
            authMiddleware,
            roleMiddleware,
        ],
        meta: {
            authorize: [RolesHelper.Roles.User],
        },
        children: [
            {
                path: 'me',
                name: 'user-profile',
                component: () => import('@/views/User/Profile.vue'),
            },
            {
                path: 'dashboard',
                name: 'user-dashboard',
                component: () => import('@/views/User/Dashboard.vue'),
            },
        ],
    },
]

export default user